import z from 'zod';
import { noLeadingSpace } from './zodHelpers';

export const eventSchema = z.object({
  title: z
    .string()
    .min(1, 'Title is required')
    .refine((val) => !/^\s+/.test(val), {
      message: 'Title cannot start with spaces',
    }),

  name: z
    .string()
    .min(1, 'Event name is required')
    .refine((val) => !/^\s+/.test(val), {
      message: 'Event name cannot start with spaces',
    }),

  date: z.date({ required_error: 'Date is required' }),

  // level: z
  //   .string()
  //   .min(1, 'Level is required')
  //   .refine((val) => !/^\s+/.test(val), {
  //     message: 'Level cannot start with spaces',
  //   }),

  place: z
    .string()
    .min(1, 'Place is required')
    .regex(/^[a-zA-Z0-9\s]+$/, 'Place cannot contain special characters')
    .refine((val) => !/^\s+/.test(val), {
      message: 'Place cannot start with spaces',
    }),

  description: z
    .string()
    .min(1, 'Description is required')
    .refine((val) => !/^\s+/.test(val), {
      message: 'Description cannot start with spaces',
    }),
  file: z.any().refine((file) => file instanceof File, {
    message: 'Event image is required',
  }),
});
export const candidateSchema = z.object({
  name: noLeadingSpace('Name'),
  email: z.string().email('Invalid email').optional().or(z.literal('')),
  walletAddress: z
    .string()
    .min(1, 'Wallet address is required')
    .regex(/^0x[a-fA-F0-9]{40}$/, 'Invalid wallet address'),
  type: noLeadingSpace('Type'),
});
export const singleCertificateSchema = z.object({
  // type: z.string().min(1, 'Certificate type is required'),
  title: noLeadingSpace('Title'),
  issuingAuthority: noLeadingSpace('Issuing Authority'),
  level: noLeadingSpace('Level'),
  date: z
    .date()
    .nullable()
    .refine((val) => val !== null, {
      message: 'Date is required',
    }),
  description: noLeadingSpace('Description'),
  // eventId: z.string().min(1, 'Event ID is required'),

  // candidate: candidateSchema,
  candidates: z.array(candidateSchema).min(1, 'At least one candidate is required'),
});

export const bulkCertificateSchema = z
  .object({
    title: noLeadingSpace('Title'),
    issuingAuthority: noLeadingSpace('Issuing Authority'),
    level: noLeadingSpace('Level'),
    date: z
      .date()
      .nullable()
      .refine((val) => val !== null, {
        message: 'Date is required',
      }),
    description: noLeadingSpace('Description'),

    bulkCount: z
      .number()
      .optional()
      .refine((val) => !val || val > 0, {
        message: 'Bulk count must be greater than 0',
      }),

    generatePlaceholders: z.boolean(),

    file: z.any().optional(),
  })
  // .superRefine((data, ctx) => {
  //   const hasFile = !!data.file;
  //   const hasPlaceholder = data.generatePlaceholders;
  //   const hasBulk = data.bulkCount && data.bulkCount > 0;

  //   if (!hasFile && !hasPlaceholder && !hasBulk) {
  //     ctx.addIssue({
  //       path: ['file'],
  //       message: 'Please upload CSV file',
  //       code: z.ZodIssueCode.custom,
  //     });

  //     ctx.addIssue({
  //       path: ['bulkCount'],
  //       message: 'Enter certificate count',
  //       code: z.ZodIssueCode.custom,
  //     });

  //     ctx.addIssue({
  //       path: ['generatePlaceholders'],
  //       message: 'Or enable placeholders',
  //       code: z.ZodIssueCode.custom,
  //     });
  //   }
  // });
  .superRefine((data, ctx) => {
    const hasFile = !!data.file;
    const hasPlaceholder = data.generatePlaceholders === true;
    const hasBulk = typeof data.bulkCount === 'number' && data.bulkCount > 0;

    if (!hasFile) {
      ctx.addIssue({
        path: ['file'],
        message: 'CSV file is required',
        code: z.ZodIssueCode.custom,
      });
    }

    if (!hasBulk) {
      ctx.addIssue({
        path: ['bulkCount'],
        message: 'Enter certificate count',
        code: z.ZodIssueCode.custom,
      });
    }

    if (!hasPlaceholder) {
      ctx.addIssue({
        path: ['generatePlaceholders'],
        message: 'Enable placeholders',
        code: z.ZodIssueCode.custom,
      });
    }
  });
export const changePasswordSchema = z.object({
  oldPassword: z
    .string()
    .min(6, 'Enter your old password')
    .refine((val) => !/^\s+/.test(val), {
      message: 'Password cannot start with spaces',
    }),

  newPassword: z
    .string()
    .min(6, 'Password must be at least 6 characters')
    .refine((val) => !/^\s+/.test(val), {
      message: 'Password cannot start with spaces',
    })
    .refine((val) => /[A-Z]/.test(val) && /[a-z]/.test(val) && /[0-9]/.test(val), {
      message:
        'Password must contain at least 6 characters, one uppercase letter, one lowercase letter, and one number',
    }),
});
